import { Injectable } from '@angular/core';
import { offlineDb, OfflineBlobRow } from './offline-db';

@Injectable({ providedIn: 'root' })
export class OfflineBlobService {
  async putFile(file: File | Blob, fileName?: string): Promise<string> {
    const id = `blob_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    const bytes = await file.arrayBuffer();
    const row: OfflineBlobRow = {
      id,
      mimeType: file.type || 'application/octet-stream',
      fileName: fileName || (file instanceof File ? file.name : 'attachment'),
      bytes,
      createdAt: Date.now(),
    };
    await offlineDb.blobs.put(row);
    return id;
  }

  async get(id: string): Promise<OfflineBlobRow | undefined> {
    return offlineDb.blobs.get(id);
  }

  async toFile(id: string): Promise<File | null> {
    const row = await offlineDb.blobs.get(id);
    if (!row) return null;
    return new File([row.bytes], row.fileName, { type: row.mimeType });
  }

  async objectUrl(id: string): Promise<string | null> {
    const row = await offlineDb.blobs.get(id);
    if (!row) return null;
    const blob = new Blob([row.bytes], { type: row.mimeType });
    return URL.createObjectURL(blob);
  }

  async remove(id: string): Promise<void> {
    await offlineDb.blobs.delete(id);
  }
}
